import  { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CategoryChildrenComponent
} from '~shared/modules/catalog/catalog-products-list/modules/category-children/category-children.component';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { TooltipModule } from '~shared/modules/tooltip/tooltip.module';
import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmFlexLayoutModule,
    TooltipModule,
    DefaultImageModule,
    RouterModule,
    MmIconModule,
    LazyLoadImageModule
  ],
  declarations: [
    CategoryChildrenComponent
  ],
  exports: [
    CategoryChildrenComponent
  ],
})
export class CategoryChildrenModule {}
